/** 
  All of the routes for the Soft UI Dashboard PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Soft UI Dashboard PRO React layouts
import Default from "layouts/dashboards/default";
import Settings from "layouts/pages/account/settings";
import Error404 from "layouts/authentication/error/404";
import HomePage from "layouts/pages/landing/homepage";
import FormularSesizare from "layouts/pages/landing/formular-sesizare";
import FormulareVerificare from "layouts/pages/landing/formulare-verificare";
import CeTrebuieSaStii from "layouts/pages/landing/ce-trebuie-sa-stii";
import DrepturileVictimelor from "layouts/pages/landing/drepturile-victimelor";
import GhidUtilizare from "layouts/pages/landing/ghid";
import Multimedia from "layouts/pages/landing/multimedia";
import FeedbackFormPage from "layouts/pages/landing/feedback-form";
import DashboardPanouPrincipal from "layouts/pages/dashboard/panou-principal";
import DashboardDetaliiSesizare from "layouts/pages/dashboard/detalii-sesizare";
import DashboardSesizariNevalidate from "layouts/pages/dashboard/sesizari-nevalidate";
import DashboardSesizariClasate from "layouts/pages/dashboard/sesizari-clasate";
import DashboardSesizariRedirectionate from "layouts/pages/dashboard/sesizari-redirectionate";
import DashboardSesizariSolutionate from "layouts/pages/dashboard/sesizari-solutionate";

// Soft UI Dashboard PRO React icons
import Shop from "examples/Icons/Shop";
import SpaceShip from "examples/Icons/SpaceShip";
import CustomerSupport from "examples/Icons/CustomerSupport";
import Document from "examples/Icons/Document";
import Office from "examples/Icons/Office";
import LogIn from "layouts/authentication/sign-in/basic";
import AuthGuard from "utils/authGuard";
import Statistics from "layouts/pages/dashboard/statistics/statistics";

const routes = [
  {
    key: "login",
    name: "Autentificare",
    route: "/authentication/signIn",
    component: <LogIn />,
  },
  {
    key: "homepage",
    route: "/",
    component: <HomePage />,
  },
  {
    key: "formular-sesizare",
    route: "/formular-sesizare",
    component: <FormularSesizare />,
  },
  {
    key: "formulare-verificare",
    route: "/status-sesizare",
    component: <FormulareVerificare />,
  },
  {
    key: "ce-trebuie-sa-stii",
    route: "/ce-trebuie-sa-stii",
    component: <CeTrebuieSaStii />,
  },
  {
    key: "drepturile-victimelor",
    route: "/drepturile-victimelor",
    component: <DrepturileVictimelor />,
  },
  {
    key: "ghid",
    route: "/ghid",
    component: <GhidUtilizare />,
  },
  {
    key: "multimedia",
    route: "/multimedia",
    component: <Multimedia />,
  },
  {
    key: "feedback-form-preview",
    route: "/forms/:token",
    component: <FeedbackFormPage />,
  },
  
  {
    type: "collapse",
    name: "Panou principal",
    key: "dashboard",
    route: "/dashboard/panou-principal",
    icon: <Office size="12px" />,
    component: <AuthGuard><DashboardPanouPrincipal/></AuthGuard>,
    noCollapse: true,
  },
  {
    key: "detalii-sesizare",
    route: "/dashboard/detalii-sesizare/:id",
    component: <AuthGuard><DashboardDetaliiSesizare/></AuthGuard>,
  },
  {
    type: "collapse",
    name: "Redirectionari",
    key: "redirectionari",
    route: "/redirectionari",
    icon: <SpaceShip size="12px" />,
    component: <AuthGuard><DashboardSesizariRedirectionate /></AuthGuard>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Solutionate",
    key: "solutionate",
    route: "/solutionate",
    icon: <CustomerSupport size="12px" />,
    component: <AuthGuard><DashboardSesizariSolutionate /></AuthGuard>,
    noCollapse: true,
  },
    {
    type: "collapse",
    name: "Sesizari Nevalidate",
    key: "sesizari-nevalidate",
    route: "/sesizari-nevalidate",
    icon: <Shop size="12px" />,
    component: <AuthGuard><DashboardSesizariNevalidate /></AuthGuard>,
    noCollapse: true,
  },
  // Sesizari Clasate — dezactivat temporar
  // {
  //   type: "collapse",
  //   name: "Sesizari Clasate",
  //   key: "sesizari-clasate",
  //   route: "/sesizari-clasate",
  //   icon: <Shop size="12px" />,
  //   component: <AuthGuard><DashboardSesizariClasate /></AuthGuard>,
  //   noCollapse: true,
  // },
  // Ascuns temporar - Statistici si Rapoarte
  // {
  //   type: "collapse",
  //   name: "Statistici si Rapoarte",
  //   key: "statistici-rapoarte",
  //   route: "/statistici-rapoarte",
  //   icon: <Document size="12px" />,
  //   component: <Default />,
  //   noCollapse: true,
  // },
  // Statistici — dezactivat temporar
  // {
  //   type: "collapse",
  //   name: "Statistici",
  //   key: "statistici",
  //   route: "/statistici",
  //   icon: <CustomerSupport size="12px" />,
  //   component: <Statistics />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Setari Cont",
    key: "setari-cont",
    route: "/setari-cont",
    icon: <CustomerSupport size="12px" />,
    component: <AuthGuard><Settings /></AuthGuard>,
    noCollapse: true,
  },
  // Pagina 404 nu este accesibilă direct prin URL
  // {
  //   key: "error-404",
  //   route: "/authentication/error/404",
  //   component: <Error404 />,
  // },
];

export default routes;
